import React from "react";
import { ComponentProps, KontentRichText } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import * as styles from "./ArboretumHeadline.module.css";

interface Props extends ComponentProps {
  title: string;
  text?: KontentRichText;
}

export const ArboretumHeadline: React.FC<Props> = ({
  title,
  text,
  ...props
}) => {
  return (
    <SectionWrapper {...props}>
      <div
        className={styles.arboretumheadline}
        data-kontent-element-codename="title"
      >
        <h2>{title}</h2>
        {text && text?.value !== "<p><br></p>" && (
          <div
            className={styles.text}
            data-kontent-element-codename="simple_rte__text"
          >
            <CustomRichTextElement content={text} />
          </div>
        )}
      </div>
    </SectionWrapper>
  );
};
